<template>
  <HXContentCard title="Lista de Departamentos">
    <div class="text-right px-4 mt-4">
      <div class="d-flex justify-content-end">
        <vs-button icon animation-type="vertical" class="mx-1 text-right" @click="$router.push('Departamentos_agregar')"
          id="DepartamentoAgregar">
          <i class="fas fa-plus-circle px-1"></i>
          Agregar Departamento
          <template #animate>
            <i class="fas fa-plus-circle"></i>
          </template>
        </vs-button>

        <vs-button id="startButton" v-b-tooltip.hover title="Iniciar tutorial" circle icon danger relief
          @click="startTour">
          <i class="far fa-circle-play mr-1"></i>
          Tutorial Rápido
        </vs-button>
        <!-- tour guide -->
        <TourGuideLineal ref="tourGuide" />
      </div>
    </div>

    <div class="table-responsive px-4 mt-3" id="DepartamentosRegistrados">
      <table id="datatable_departamentos" class="table table-bordered table-responsive-md table-striped text-center">
        <thead>
          <tr>
            <th>#</th>
            <th>Nombre Departamento</th>
            <th>Sucursal</th>
            <th>Empresa</th>
            <th>Estado</th>
            <th>Opciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in listaItems" :key="item.id">
            <td>
              <strong>{{ index + 1 }}</strong>
            </td>
            <td>{{ item.descripcion }}</td>
            <td>{{ item.sucursal.descripcion }}</td>
            <td>{{ item.empresa.nombre }}</td>
            <td>{{ item.estado == 1 ? "Activo" : "Inactivo" }}</td>
            <td style="width: 150px !important" id="OpcionesDepartamentos">
              <ButtonGroup :Id="item.id" :data="dataIcons"></ButtonGroup>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </HXContentCard>
</template>
<script>
import { core } from "../../../config/pluginInit";
import ButtonGroup from "../../../components/ButtonGroup/ButtonGroup.vue";
import TourGuideLineal from "@/components/helexium/TourGuideLineal.vue";


const Swal = require("sweetalert2");

export default {
  components: {
    ButtonGroup,
    TourGuideLineal

  },
  name: "DataTable",
  data() {
    return {
      listaItems: [],
      logoEmpresa: "",
      usuario: {},
      tourSteps: [
        {
          title: "Departamentos Registrados",
          description:
            "En este apartado encontrarás los Departamentos asociados a cada Sucursal de tu empresa, adicionalmente tienes un buscador el cual ayudará a filtrar los datos más fácilmente.",
          elementId: "DepartamentosRegistrados",
        },
        {
          title: "Opciones Departamentos",
          description:
            "En este apartado encontrarás los botones u opciones que tendremos para editar o eliminar algún departamento que ya no necesitemos.",
          elementId: "OpcionesDepartamentos",
        },
        {
          title: "Agregar Departamento",
          description:
            "En este botón podrás registrar o agregar un nuevo Departamento a tu empresa y asociarlo a una Sucursal.",
          elementId: "DepartamentoAgregar",
          redireccionarOtroPasoAPaso: "Departamentos_agregar" //Nombre de la vista a redireccionar
        },
      ],
      dataIcons: [
        {
          type: "success",
          tooltip: "Editar Departamento",
          title: "",
          value: () => 10,
          iconName: "pen",
          color: "rgba(22, 162, 117, 1)",
          tipo: "squared",
          animated: "bounce",
          onActivate: (Id) => {
            console.log("Activated");
            this.$router.push("departamentos_editar/" + Id);
          },
          onDeactivate: () => {
            console.log("Deactivate");
          },
        },
        {
          type: "danger",
          tooltip: "Eliminar registro",
          title: "",
          value: () => 0,
          iconName: "trash",
          color: "rgba(22, 162, 117, 1)",
          tipo: "squared",
          animated: "bounce",
          onActivate: (Id) => {
            console.log("Activated");
            this.deleteRow(Id);
          },
          onDeactivate: () => {
            console.log("Deactivate");
          },
        },
      ],
    };
  },
  async mounted() {
    try {
      this.$isLoading(true);
      this.usuario = JSON.parse(localStorage.getItem("setPersonaAct"));
      await this.getData();
      core.index();
      window.$("#datatable_departamentos").DataTable({
        language: {
          url: "//cdn.datatables.net/plug-ins/1.10.15/i18n/Spanish.json",
        },
      });
      this.$isLoading(false);
    } catch (error) {
      this.$isLoading(false);
      console.log("error", error);
    }
  },
  methods: {
    async deleteRow(id) {
      Swal.fire({
        title: "Seguro eliminar registro?",
        text: "Después de eliminarlo no podrás recuperarlo!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si!",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          //let loader = this.$loading.show();
          await this.$store.dispatch("hl_get", {
            path: "Departamento/DeleteDepartamento/" + id,
          });

          //console.log("res", res);
          //loader.hide()
          await this.getData();

          Swal.fire("Listo!", "Registro eliminado correctamente.", "success");
        }
      });
    },
    async getData() {
      //console.log(this.persona.empresa.id);
      try {
        console.log("departamentoss.....................");
        let res = await this.$store.dispatch("hl_get", {
          path: "Departamento/ListDepartamento/" + this.usuario.empresa.id,
        });
        console.log("post departamento... ", res);
        if (res.length > 0) {
          this.listaItems = res;
        } else {
          this.listaItems = [];
        }
      } catch (error) {
        this.listaItems = [];
        console.log("err", error);
      }
    },
    startTour() {
      console.log(this.listaItems[0].id);
      this.$refs.tourGuide.startTour(
        this.tourSteps
      );
    },
  },
};
</script>
